import useOnboardingPortalStore from "../OnboardingPortal.Store";
import Modal from "../../../components/modal/Modal";
import { EonUiButton } from "@eon-ui/eon-ui-components-react";
import { useTranslation } from "@me8eon/translation";
import OnboardingPortalAppIcon from "../components/OnboardingPortalAppIcon";
import { getCompanyDisplayList } from "../OnboardingPortal.utils";
import ActivityLogScreen from "./ActivityLogScreen";

const ViewAppsModal = () => {
    const t = useTranslation();
    const { showModule, showViewApp, viewAppData, resetViewApp } =
        useOnboardingPortalStore();

    return (
        <>
            <Modal
                toggleModal={showViewApp}
                closeModal={resetViewApp}
                isCloseIcon={false}
                closeOnBackdrop={true}
                modalClass="review-modal"
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                        padding: 20,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 12,
                            alignItems: "center",
                        }}
                    >
                        <OnboardingPortalAppIcon
                            icon={viewAppData?.icon}
                            iconUrl={viewAppData?.iconDataUrl}
                        />
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {viewAppData?.title}
                            </span>
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {viewAppData?.subTitle}
                            </span>
                        </div>
                        {(showModule === "review-dashboard" ||
                            showModule === "review-apps") && (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 4,
                                    marginLeft: "auto",
                                    textAlign: "right",
                                }}
                            >
                                <span
                                    style={{
                                        color: "#666666",
                                        fontSize: "14px",
                                    }}
                                >
                                    {t(`onboardingPortal.modalLabel.owner`)}
                                </span>
                                <span
                                    style={{
                                        color: "#1E1E1E",
                                        fontSize: "20px",
                                        fontWeight: "medium",
                                    }}
                                >
                                    {viewAppData?.owner}
                                </span>
                            </div>
                        )}
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                                marginLeft: "auto",
                                textAlign: "right",
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.createdOn`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {new Date(
                                    viewAppData?.createdAt || ""
                                ).toLocaleString()}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                                marginLeft: "auto",
                                textAlign: "right",
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.status`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                                className={`status ${viewAppData?.status}`}
                            >
                                {t(
                                    `onboardingPortal.statusLabel.${viewAppData?.status}`
                                )}
                            </span>
                        </div>
                        {(showModule === "review-dashboard" ||
                            showModule === "review-apps") && (
                            <ActivityLogScreen
                                key={`app-activity-log-${viewAppData?.id}`}
                                entityType="app"
                                entityData={viewAppData}
                            />
                        )}
                    </div>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 12,
                            alignItems: "center",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.url`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {viewAppData?.url}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.tooltip`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {viewAppData?.tooltip}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(
                                    `onboardingPortal.modalLabel.companiesAllowed`
                                )}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {getCompanyDisplayList(
                                    viewAppData?.companiesAllowed
                                ).join(", ")}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(
                                    `onboardingPortal.modalLabel.companiesRestricted`
                                )}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {getCompanyDisplayList(
                                    viewAppData?.companiesRestricted
                                ).join(", ")}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.keywords`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {viewAppData?.keywords.join(", ")}
                            </span>
                        </div>
                    </div>
                    {viewAppData?.status !== "pending" &&
                        viewAppData?.reviewerNote && (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 4,
                                }}
                            >
                                <span
                                    style={{
                                        color: "#666666",
                                        fontSize: "14px",
                                    }}
                                >
                                    {t(
                                        `onboardingPortal.modalLabel.reviewerComments`
                                    )}
                                </span>
                                <span
                                    style={{
                                        color: "#1E1E1E",
                                        fontSize: "20px",
                                        fontWeight: "medium",
                                    }}
                                >
                                    {viewAppData?.reviewerNote}
                                </span>
                            </div>
                        )}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 8,
                            alignItems: "center",
                            justifyContent: "flex-end",
                        }}
                    >
                        <EonUiButton
                            rank="primary"
                            onClick={() => resetViewApp()}
                            size="small"
                            text={t("onboardingPortal.closeBtn")}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ViewAppsModal;
